<template>
  <div class="week-view">
    <!-- Заголовок с датами недели -->
    <div class="week-header">
      <div
        v-for="day in daysOfWeek"
        :key="formatDate(day)"
        class="week-day-header"
        :class="{
          'today': formatDate(day) === todayStr,
          'selected': formatDate(day) === formatDate(currentDate) && formatDate(day) !== todayStr
        }"
        @click="headerClick(day)"
      >
        {{ day.toLocaleDateString("ru", { weekday: "short", day: "numeric" }) }}
      </div>
    </div>

    <!-- Основная область недели -->
    <div class="week-body">
      <!-- Столбец для каждого дня -->
      <div
        v-for="day in daysOfWeek"
        :key="formatDate(day)"
        class="week-day-column"
        @dragover.prevent
        @drop="onDrop($event, day)"
      >
        <!-- Временные слоты -->
        <div
          v-for="slot in timeSlots"
          :key="slot"
          class="time-slot"
          @click="timeSlotClick(day, slot)"
        ></div>

        <!-- Задачи для данного дня -->
        <div
          v-for="task in tasksForDay(day)"
          :key="task.id"
          class="calendar-task"
          draggable="true"
          @dragstart="onDragStart($event, task)"
          @click.stop="taskClick(task)"
          :style="getTaskStyle(task)"
        >
          <div class="calendar-task__text">{{ task.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeekView",
  props: {
    currentDate: { type: Date, required: true },
    tasks: { type: Array, default: () => [] }
  },
  computed: {
    todayStr() {
      return this.formatDate(new Date());
    },
    daysOfWeek() {
      const start = new Date(this.currentDate);
      let dayOfWeek = start.getDay() || 7;
      if (dayOfWeek !== 1) {
        start.setDate(start.getDate() - (dayOfWeek - 1));
      }
      const days = [];
      for (let i = 0; i < 7; i++) {
        const d = new Date(start);
        d.setDate(start.getDate() + i);
        days.push(d);
      }
      return days;
    },
    timeSlots() {
      const slots = [];
      for (let t = 7; t <= 18; t += 0.5) {
        slots.push(Number(t.toFixed(1)));
      }
      return slots;
    }
  },
  methods: {
    headerClick(day) {
      this.$emit("dayHeaderClick", day);
    },
    timeSlotClick(day, slot) {
      this.$emit("timeSlotClick", day, slot);
    },
    taskClick(task) {
      this.$emit("taskClick", task);
    },
    tasksForDay(day) {
      const ymd = this.formatDate(day);
      return this.tasks.filter(t => t.date === ymd);
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    getTaskStyle(task) {
      // Используем start_hour если есть, иначе startHour
      const taskStart = task.start_hour !== undefined ? task.start_hour : task.startHour;
      const baseHour = 7;
      const cellHeight = 30;
      const intervalsFromStart = (taskStart - baseHour) * 2;
      const topOffset = intervalsFromStart * cellHeight;
      const intervalsDuration = task.duration * 2;
      const height = intervalsDuration * cellHeight;
      return {
        position: "absolute",
        top: topOffset + "px",
        left: "0",
        right: "0",
        height: (height - 4) + "px",
        backgroundColor: "#4A90E2",
        color: "#fff",
        border: "1px solid #357ABD",
        borderRadius: "4px",
        padding: "2px 4px",
        fontSize: "12px",
        overflow: "hidden"
      };
    },
    onDragStart(event, task) {
      console.log("Drag start:", task);
      event.dataTransfer.setData("text/plain", String(task.id));
      event.dataTransfer.effectAllowed = "move";
    },
    onDrop(event, day) {
      const rect = event.currentTarget.getBoundingClientRect();
      const offsetY = event.clientY - rect.top;
      const cellHeight = 30;
      const slotIndex = Math.floor(offsetY / cellHeight);
      const newStartTime = 7 + slotIndex * 0.5;
      console.log("Drop offsetY:", offsetY, "=> slot index:", slotIndex, "newStartTime:", newStartTime);
      const taskId = event.dataTransfer.getData("text/plain");
      if (taskId) {
        this.$emit("taskDropped", { taskId, newDate: day, newStartTime });
      }
    }
  }
};
</script>

<style scoped>
.week-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.week-header {
  display: flex;
  background: #f0f0f0;
  border-bottom: 1px solid #ccc;
}
.week-day-header {
  flex: 1;
  text-align: center;
  padding: 8px;
  border-right: 1px solid #ccc;
  cursor: pointer;
}
.week-day-header:last-child {
  border-right: none;
}
.week-day-header.today {
  background-color: rgba(255, 220, 40, 0.15);
}
.week-day-header.selected {
  background-color: rgba(188, 232, 241, 0.3);
}
.week-body {
  flex: 1;
  display: flex;
  position: relative;
}
.week-day-column {
  flex: 1;
  border-right: 1px solid #ccc;
  position: relative;
  box-sizing: border-box;
  padding: 4px;
}
.week-day-column:last-child {
  border-right: none;
}
.time-slot {
  height: 30px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.calendar-task {
  position: absolute;
  box-sizing: border-box;
  cursor: move;
}
</style>
